import { render } from "./ContactSupport.vue?vue&type=template&id=22e6d0ee&scoped=true"
import script from "./ContactSupport.vue?vue&type=script&lang=js"
export * from "./ContactSupport.vue?vue&type=script&lang=js"

import "./ContactSupport.vue?vue&type=style&index=0&id=22e6d0ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e6d0ee"]])

export default __exports__